require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./epfl-fribourg-0-4-3.json") })
        }
      }, "path---epfl-fribourg-0-4-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---epfl-fribourg-0-4-3!./.cache/json/epfl-fribourg-0-4-3.json
// module id = 413
// module chunks = 231608221292675